import { formatNumber, Stack } from 'ui';

import { formatPercentageFeature } from '../../utils/formatFeature/formatFeature';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';
import { MaterialSampleBreakdownItem } from '../MaterialSampleBreakdownItem/MaterialSampleBreakdownItem';

const ZORBA_SUM_KEYS: string[] = [
  "Non-ferrous Metal 'whites'",
  "Copper & Brass 'reds & yellows'",
  'Post-consumer Aluminium Packaging',
  'Composite Materials',
  'Aluminium - UBC',
];

const NON_ZORBA_SUM_KEYS: string[] = ['Other Metal', 'Non-Metal', 'Prohibitive', 'Ferrous metal', 'Fines <20mm'];

export const ZorbaMaterialSampleBreakdown = ({
  totalWeight,
  breakdown,
  precision = 1,
}: {
  totalWeight: number;
  breakdown: Record<string, number>;
  precision?: number;
}) => {
  const totalZorba = ZORBA_SUM_KEYS.reduce((acc, key) => acc + (breakdown[key] ?? 0), 0);
  const totalNonZorba = NON_ZORBA_SUM_KEYS.reduce((acc, key) => acc + (breakdown[key] ?? 0), 0);

  const otherMetal = (breakdown['Ferrous metal'] || 0) + (breakdown['Other Metal'] || 0);

  return (
    <Stack gap={2}>
      <div>
        <MaterialBreakdownItem
          label={'Target Material'}
          variant="bold"
          value={formatNumber(totalZorba, {
            maximumFractionDigits: precision,
            minimumFractionDigits: precision,
            style: 'kilogram',
          })}
          secondaryValue={formatPercentageFeature(totalZorba / totalWeight)}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown["Non-ferrous Metal 'whites'"]}
          label={"Non-ferrous metal - 'whites'"}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown["Copper & Brass 'reds & yellows'"]}
          label={"Copper & Brass - 'reds & yellows'"}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Post-consumer Aluminium Packaging']}
          label={'Post-consumer Aluminium Packaging'}
          totalWeight={totalWeight}
        />

        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Composite Materials']}
          label={'Composite Materials'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Aluminium - UBC']}
          label={'Aluminium - UBC'}
          totalWeight={totalWeight}
        />
      </div>

      <div>
        <MaterialBreakdownItem
          label={'Non-target'}
          variant="bold"
          value={formatNumber(totalNonZorba, {
            maximumFractionDigits: precision,
            minimumFractionDigits: precision,
            style: 'kilogram',
          })}
          secondaryValue={formatPercentageFeature(totalNonZorba / totalWeight)}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={otherMetal}
          label={'Other Metal (ferrous)'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Non-Metal']}
          label={'Other Non-Metal'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown['Fines <20mm']}
          label={'Fines <20mm'}
          totalWeight={totalWeight}
        />
        <MaterialSampleBreakdownItem
          precision={precision}
          value={breakdown.Prohibitive}
          label={'Prohibitive'}
          totalWeight={totalWeight}
        />
      </div>

      <MaterialBreakdownItem
        label="Total"
        value={formatNumber(totalWeight, {
          maximumFractionDigits: precision,
          minimumFractionDigits: precision,
          style: 'kilogram',
        })}
        secondaryValue={'100%'}
        variant="bold"
      />
    </Stack>
  );
};
